// @ts-nocheck
import { LocalNotifications } from "@capacitor/local-notifications";
import { add } from "date-fns";
import { concatMap, from, map } from "rxjs";
import { newUserDateTime } from "../../utils/date";
import { logWatch } from "../../utils/logger";
import { NotificationSchedule } from "./Device.interface";

export class NotificationsManager {
  private imports = [import("@capacitor/local-notifications")];

  importer() {
    from(this.imports);
  }

  async isEnabled() {
    const check = await LocalNotifications.checkPermissions();
    console.log("Notifications status", check);
    return check.display === "granted";
  }

  async enableNativeNotifications() {
    const enabled = await this.isEnabled();
    if (!enabled) {
      return await LocalNotifications.requestPermissions();
    }
  }

  scheduleNativeNotifications({
    notificationId,
    title,
    body,
    at,
    attachements,
  }: {
    notificationId: number;
    title: string;
    body: string;
    at: Date;
    attachements?: Array<{ id: string; url: string }>;
  }) {
    return from(
      LocalNotifications.schedule({
        notifications: [
          {
            title,
            body,
            id: notificationId,
            schedule: { at },
            attachments: attachements ?? [],
          },
        ],
      })
    ).pipe(concatMap(() => LocalNotifications.getPending()));
  }

  @logWatch
  scheduleNotification({
    notificationId,
    title,
    body,
    schedule,
    options,
  }: {
    notificationId: number;
    title: string;
    body: string;
    schedule: NotificationSchedule;
    options?: {
      attachements?: Array<{ id: string; url: string }>;
      delay: { hours: number; minutes: number; seconds: number };
    };
  }) {
    const scheduleDate = options?.delay
      ? add(newUserDateTime({ ...schedule }), { ...options.delay })
      : newUserDateTime({ ...schedule });

    return this.scheduleNativeNotifications({
      notificationId,
      title,
      body,
      at: scheduleDate,
      attachements: options?.attachements,
    });
  }

  @logWatch
  cancelScheduledNotifications(notificationIds: Array<number>) {
    return from(LocalNotifications.getPending()).pipe(
      map((pending) => ({
        notifications: pending.notifications.filter((notif) =>
          notificationIds.includes(notif.id)
        ),
      })),
      concatMap((pending) => LocalNotifications.cancel(pending))
    );
  }
}
